import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpResponse, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, throwError, BehaviorSubject } from 'rxjs';
import { catchError, retry, map, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { BookingListProperties, BookingRights, BookingStatus, loginUserList, managerlistbyuserid } from '../Models/BookingListProperties';
import { Agencies_BranchesProperties, AgencyMasterProperties } from '../Models/AgencyMasterProperties';
import { OfflineBookingAllList, OfflineRequestType } from '../Models/OfflineBookingProperties';
import { TravelInsuranceBookedPassengers } from '../Models/TravelInsuranceProperties';
@Injectable({
  providedIn: 'root'
})
export class BookingListService {
  baseUrl = environment.baseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }


  GetAllAgencies(param, userId): Observable<Agencies_BranchesProperties[]> {
    return this.http.get<Agencies_BranchesProperties[]>(this.baseUrl + '/AgencyMaster/GetAllAgencies/' + param + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }



  
  GetBookingRights(agencyId, userId): Observable<BookingRights> {
    return this.http.get<BookingRights>(this.baseUrl + '/BookingList/GetBookingRights/' + agencyId + "/" + userId)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  getBookingrequestId(bookingid): Observable<BookingListProperties> {
    return this.http.get<BookingListProperties>(this.baseUrl + '/BookingList/GetBookingDetailsFromOfflineList/' + bookingid)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  GetAllBookingStatus(): Observable<BookingStatus[]> {
    return this.http.get<BookingStatus[]>(this.baseUrl + '/BookingList/GetBookingStatusList')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetBookingSearch(ctcno): Observable<BookingListProperties[]> {
    return this.http.post<BookingListProperties[]>(this.baseUrl + '/BookingList/GetBookinglistBySearchCriteria', ctcno, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }


  GetAllAgencyUserName(obj): Observable<loginUserList[]> {
    return this.http.get<loginUserList[]>(this.baseUrl + '/BookingList/GetLoinUserByAgencyBranch/' + obj)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetB2BBackOfficebookinglistBySearchCriteria(obj): Observable<BookingListProperties[]> {
    return this.http.post<BookingListProperties[]>(this.baseUrl + '/BookingList/GetB2BBackOfficebookinglistBySearchCriteria', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  GetB2BBackOfficeInsuranceConfirmedlistBySearchCriteria(obj): Observable<TravelInsuranceBookedPassengers[]> {
    return this.http.post<TravelInsuranceBookedPassengers[]>(this.baseUrl + '/TravelInsurance/GetInsuredPassengerData', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  getmanagerlistbyuserid(userid): Observable<managerlistbyuserid[]> {
    return this.http.get<managerlistbyuserid[]>(this.baseUrl + '/BookingList/GetManagersDetailsWithAgencies/' + userid)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  getBookingList(bookingNew): Observable<BookingListProperties[]> {
    return this.http.post<BookingListProperties[]>(this.baseUrl + '/BookingList/GetBookingList', bookingNew)
      .pipe(map((data: any) => { return data; }), catchError(error => { return throwError(error); }))
  }

  ManagerGetProficiency(obj): Observable<OfflineBookingAllList[]> {
    return this.http.post<OfflineBookingAllList[]>(this.baseUrl + '/BookingList/ManagerGetProficiency', obj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetOfflineRequestTypeList(): Observable<OfflineRequestType[]> {
    return this.http.get<OfflineRequestType[]>(this.baseUrl + '/BookingList/GetOfflineRequestTypeList')
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
}
